import type {FC, SVGProps} from 'react';
import {cn} from '../lib/utils';
import type {AccentColor} from '../lib/color';

/**
 * Only the mono sets take a role: their artwork paints with `currentColor`, which is what the `color`
 * presentation attribute feeds — globals.css turns each role into a real colour. Brand icons keep their
 * vendor palette and stay on plain SVGProps, where `color` is any CSS colour.
 *
 * Omit `color` and the icon inherits the surrounding text colour, which is how Button and DropdownMenu
 * have always used these — so the greys need no role of their own.
 */
export type IconColor = AccentColor;

export const ICON_SIZES = {
	xs: 'size-3',
	sm: 'size-4',
	md: 'size-5',
	lg: 'size-6',
	xl: 'size-10'
};

export type IconSize = keyof typeof ICON_SIZES;

export type IconProps = Omit<SVGProps<SVGSVGElement>, 'color'> & {color?: IconColor; size?: IconSize};

export type IconComponent = FC<IconProps>;

export type BrandIconProps = SVGProps<SVGSVGElement> & {size?: IconSize};

export type BrandIconComponent = FC<BrandIconProps>;

type SizedIcon = FC<SVGProps<SVGSVGElement> & {size?: IconSize}>;

export function createIcon(Svg: FC<SVGProps<SVGSVGElement>>): SizedIcon {
	return ({size = 'sm', className, ...props}) => <Svg {...props} className={cn(className, ICON_SIZES[size])}/>;
}
